<template>
  <div
    class="ts-w-full ts-h-full ts-z-40 ts-absolute ts-top-0 ts-left-0 ts-overflow-y-scroll"
  >
    <div style="width: fit-content;" class="ts-m-auto ts-text-center">
      <h1 class="ts-font-extrabold ts-font-teko ts-text-4xl">
        {{ yearDate }}
      </h1>
      <h1 class="ts-font-extrabold ts-font-teko ts-text-xl">
        Class of Academic Year: --
      </h1>
    </div>
    <ImageFrame :image="imag" class="ts-m-auto ts-mt-8" :isStar="true"/>
    <div
      class="ts-grid ts-grid-cols-2 sm:ts-grid-cols-3 ts-gap-16 ts-m-auto ts-mt-8"
      style="width: fit-content;"
    >
      <ImageFrame :image="imag" v-for="i in 3" :key="i" :isStar="true" starColor="ts-text-gray-400"/>
    </div>
    <br />
    <br />
    <div
      class="ts-grid ts-grid-cols-2 sm:ts-grid-cols-5 ts-gap-16 ts-m-auto"
      style="width: fit-content;"
    >
      <ImageFrame :image="imag" v-for="i in 15" :key="i"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ImageFrame from './imageFram.vue'
export default {
  components: {
    ImageFrame
  },
  data() {
    return {
      imag:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZ-E9SDEDulPGoTrUX-gAxgC9QiMYcQPTgZw&usqp=CAU'
    }
  },
  computed: {
    yearDate() {
      return (
        moment().format('YYYY') +
        '-' +
        moment()
          .add(1, 'year')
          .format('YYYY')
      )
    }
  }
}
</script>
